import styled from 'styled-components';

export const ContainerHeaderUser = styled.div`
  height: 220px;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  a:first-child {
    height: 156px;
  }
  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    > p {
      font-family: 'Inter';
      font-size: 32px;
      line-height: 36px;
      letter-spacing: 0em;
      text-align: center;
      margin: 16px 0 16px 0;
    }
    > button {
      background: none;
      border: none;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;
      letter-spacing: -0.002em;
      text-align: center;
      margin-bottom: 0;
      color: ${props => props.theme.colors?.primary.main.color};
      cursor: pointer;
    }
  }
  @media (max-width: 650px) {
    height: auto;
  }
`;

export const AvatarPicture = styled.img`
  width: 138px;
  height: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

export const EditAvatarIcon = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Elipse = styled.button`
  background-color: #005cde;
  border-radius: 50% !important;
  border: none;
  padding: 0;
  width: 48px;
  height: 48px;
  bottom: 48px;
  left: 48px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  position: relative;
`;

export const Pencil = styled.img`
  width: 30px;
  height: 30px;
`;
